import Backbone from 'backbone'
import {
  detailWithTitleHandler,
  selectMultiGoods,
} from '../../manager/view.handler'
import { GoodsCounterView } from '../decoration/goodsCounter.view'
import { EmoticonCollection } from './emoticon.collection'
import { EmoticonFilterView } from './emoticonFilter.view'

import tpl from './emoticon.mustache'

/**
 *  이모티는 뷰 : dcoration.model / goodsCounterView 공유
 */
export var EmoticonView = Backbone.View.extend({
  tagName: 'div',
  className: 'EmoticonView',
  collection: new EmoticonCollection(),
  template: tpl,
  events: {
    'click [data-id]': selectMultiGoods,
    'click [data-detail-pop]': detailWithTitleHandler,
  },
  initialize: function () {
    this.collection.once('sync', this.render, this)
    this.collection.fetch()
  },
  // Method
  resetSelected: function () {
    this.collection.resetSelectedGoods()
    $('[data-id]').attr('class', 'selected--false')
    $('.poker-mall-decoration__list:visible')
      .find('ul>li:visible:eq(0)>a[data-id]')
      .trigger('click')
  },
  render: function () {
    var $decoHead = $('<div class=poker-mall-decoration__head />')
    var $decoBody = this.template.render({
      emoticon: this.collection.toJSON(),
    })

    var goodsCounterView = new GoodsCounterView({
      collection: this.collection,
    })
    var emoticonFilterView = new EmoticonFilterView({
      collection: this.collection,
      resetSelected: this.resetSelected,
    })

    $decoHead.append(
      emoticonFilterView.render().$el,
      goodsCounterView.render().$el
    )
    this.$el.empty().append($decoHead, $decoBody)
    return this
  },
})
